import React, { useCallback, useEffect } from 'react'

import MenuItem from '@material-ui/core/MenuItem'
import { CampoDeTextoOutlined } from '../styles'
import { useDispatch, useSelector } from 'react-redux'
import { IStoreRedux } from 'Types/Reducers'
import { primeiraMaiusculaTodasPalavras } from '../../../../_recursos/js/util'

function CampoComoConheceu() {
  const valor = useSelector<IStoreRedux, string>(state => state.dados.como_conheceu || '')
  const valorDetalhes = useSelector<IStoreRedux, string>(state => state.dados.como_conheceu_detalhes || '')
  const dispatch = useDispatch()

  const aoAlterar = useCallback((e) => {
    const novoValor = e.target.value
    dispatch({ type: 'ALTERA_COMO_CONHECEU', como_conheceu: novoValor })

    // Limpa os detalhes se mudar para uma opção que não requer detalhes
    if (novoValor !== "Amigo ou Familiar" && novoValor !== "Outro") {
      dispatch({ type: 'ALTERA_COMO_CONHECEU_DETALHES', como_conheceu_detalhes: '' })
    }
  }, [dispatch])

  const aoAlterarDetalhes = useCallback((e) => {
    let valorAlterado = e.target.value

    // Se for "Amigo ou Familiar", aplica formatação de nome
    if (valor === "Amigo ou Familiar") {
      valorAlterado = primeiraMaiusculaTodasPalavras(valorAlterado)
    }

    dispatch({ type: 'ALTERA_COMO_CONHECEU_DETALHES', como_conheceu_detalhes: valorAlterado })
  }, [dispatch, valor])

  // Verifica se deve mostrar o campo de detalhes
  const mostraDetalhes = valor === "Amigo ou Familiar" || valor === "Outro"

  // Label dinâmico baseado na seleção
  const labelDetalhes = valor === "Amigo ou Familiar"
    ? "Nome do Amigo/Familiar"
    : "Especifique"

  // Validação
  useEffect(() => {
    if (!valor) {
      dispatch({ type: 'VALIDA_CAMPO', como_conheceu: false })
      return
    }

    // Se selecionou opção que requer detalhes
    if (mostraDetalhes) {
      let detalhesValido = false

      if (valor === "Amigo ou Familiar") {
        // Valida com regex de nome completo
        const regex = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]{2,}\s([A-Za-z\s]{2,3})?[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ\s']{4,}$/
        detalhesValido = regex.test(valorDetalhes)
      } else if (valor === "Outro") {
        // Valida se não está vazio
        detalhesValido = valorDetalhes.trim().length > 0
      }

      dispatch({ type: 'VALIDA_CAMPO', como_conheceu: detalhesValido })
    } else {
      // Opções que não requerem detalhes são válidas imediatamente
      dispatch({ type: 'VALIDA_CAMPO', como_conheceu: true })
    }
  }, [dispatch, valor, valorDetalhes, mostraDetalhes])

  return (
    <>
      <CampoDeTextoOutlined
        select
        fullWidth
        label={valor === '' && 'Selecione uma opção'}
        value={valor}
        onChange={aoAlterar}
        autoComplete="off"
      >
        <MenuItem value="Google">Google</MenuItem>
        <MenuItem value="Instagram">Instagram</MenuItem>
        <MenuItem value="Facebook">Facebook</MenuItem>
        <MenuItem value="Youtube">Youtube</MenuItem>
        <MenuItem value="Amigo ou Familiar">Amigo ou Familiar</MenuItem>
        <MenuItem value="Outro">Outro</MenuItem>
      </CampoDeTextoOutlined>

      {mostraDetalhes && (
        <CampoDeTextoOutlined
          fullWidth
          label={labelDetalhes}
          value={valorDetalhes}
          onInput={aoAlterarDetalhes}
          autoComplete="off"
          style={{ marginTop: '16px' }}
        />
      )}
    </>
  )
}

export default CampoComoConheceu